import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface Props {
  title: string;
  caption: string;
  status?: ReactNode;
  isOpen: boolean;
  onToggleOpen: () => void;
}

const ContentCardLayout = ({ title, caption, status, isOpen, onToggleOpen }: Props) => {
  return (
    <Paper variant="outlined" sx={{ px: 2, py: 1.5 }}>
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" noWrap>
            {title}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {caption}
          </Typography>
        </Box>
        {status}
        <Button variant="outlined" color="secondary" onClick={onToggleOpen}>
          {isOpen ? "Hide" : "Open"}
        </Button>
      </Stack>
    </Paper>
  );
};

export default ContentCardLayout;
